import React, { Component } from 'react';

class RowsDropdown extends Component {
  constructor(props) {
    super(props);

    this.dropdownDiv = null;
    this.rowOptions = props.reducedPagination ? [100, 50, 20] : [500, 100, 50];

    this.state = {
      opened: false,
    };
  }

  componentDidMount() {
    window.addEventListener('click', event => this.handleClickOutside(event));
  }

  componentWillUnmount() {
    window.removeEventListener('click', event => this.handleClickOutside(event));
  }

  handleClickOutside(event) {
    if (!this.dropdownDiv || !this.state.opened || this.dropdownDiv.contains(event.target)) return;

    this.toggleDropdown();
  }

  toggleDropdown() {
    this.setState(
      {
        opened: !this.state.opened,
      },
      () => {
        if (this.state.opened) {
          this.props.trackOpenEvent();
        }
      },
    );
  }

  onOptionSelected(event, option) {
    event.stopPropagation();

    this.toggleDropdown();
    this.props.changeNumRows(option);
  }

  render() {
    const rows = this.rowOptions.map(option => {
      return (
        <div
          key={option}
          className="row-value"
          onClick={event => this.onOptionSelected(event, option)}
        >
          {option}
        </div>
      );
    });
    const rowsMenu = this.state.opened ? <div className="dropdown-menu">{rows}</div> : null;

    return (
      <div ref={node => (this.dropdownDiv = node)} className="rows-dropdown">
        <label>Show rows:</label>
        <div className="dropdown-toggle" onClick={this.toggleDropdown.bind(this)}>
          <span>{this.props.perPage}</span>
          <span className="dropdown-icon"></span>
        </div>
        {rowsMenu}
      </div>
    );
  }
}

export default RowsDropdown;
